export default __webpack_public_path__ + "static/media/service-available.352ded67.png";